// Keep this in sync with Representation3dType in API
// TODO: Move to a better place
enum Representation3dTypeEnum {
    NotDefined = "NotDefined",
    ExtrudedAreaSolid = "ExtrudedAreaSolid",
    TriangleMesh = "TriangleMesh",
    FbxAsset = "FbxAsset"
  }

export default Representation3dTypeEnum;